// extracted by mini-css-extract-plugin
export default {"current-supply-wrapper":"current-supply-wrapper-d7bb"};